import { FC, useRef } from 'react';

import { Text, useBreakpoint } from '@hh.ru/magritte-ui';
import { ClockFilledSize16 } from '@hh.ru/magritte-ui/icon';

import useOnOffState from 'hooks/common/useOnOffState';
import useTrls from 'hooks/translation/useTrls';

import { TooltipCommon } from 'components/common/TooltipCommon/TooltipCommon';

import { BalanceHistoryType } from 'store/models/balance';

const TrlKeys = {
    title: 'BalanceAndBonuses.History.operations.PAYMENT_NEW',
    tooltip: 'BalanceAndBonuses.History.HistoryRecords.PAYMENT_NEW.tooltip',
};

export const PaymentNewIcon: FC<{ balanceHistoryType: BalanceHistoryType }> = ({ balanceHistoryType }) => {
    const [isTooltipVisible, setIsTooltipVisibleOn, setIsTooltipVisibleOff] = useOnOffState(false);

    const activatorRef = useRef(null);
    const trls = useTrls();
    const { isMobile } = useBreakpoint();

    if (balanceHistoryType !== BalanceHistoryType.PaymentNew) {
        return null;
    }

    return (
        <>
            <ClockFilledSize16
                initialColor="warning"
                highlightedColor="warning-secondary"
                ref={activatorRef}
                onClick={setIsTooltipVisibleOn}
                onMouseEnter={isMobile ? undefined : setIsTooltipVisibleOn}
                onMouseLeave={isMobile ? undefined : setIsTooltipVisibleOff}
            />
            <TooltipCommon
                maxWidth={300}
                visible={isTooltipVisible}
                activatorRef={activatorRef}
                tooltipContent={
                    <Text typography={isMobile ? 'label-1-regular' : 'paragraph-2-regular'}>
                        {trls(TrlKeys.tooltip)}
                    </Text>
                }
                bottomSheetTitle={trls(TrlKeys.title)}
                onClose={setIsTooltipVisibleOff}
            />
        </>
    );
};
